import { login, logout, getInfo,menuList } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import MenuUtils from '@/utils/menu'
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

const getDefaultState = () => {
  return {
    token: getToken(),
    routesList: [],
    name: JSON.parse(localStorage.getItem('userName')),
    orgId: JSON.parse(localStorage.getItem('orgId')),
    orgName: JSON.parse(localStorage.getItem('orgName')),
    orgCategory: JSON.parse(localStorage.getItem('orgCategory')),
    companyId: JSON.parse(localStorage.getItem("companyId")),
    avatar: '',
    serviceCodes: '',
    expiredStatus: '',
    memberValidDate: '',
    userId: JSON.parse(localStorage.getItem('userId')),
    createOrderRole: localStorage.getItem('createOrderRole'),
    userLevel:localStorage.getItem('userLevel'),
    menuCodes:localStorage.getItem("menuCodes"),
    roleCode:localStorage.getItem("roleCode"),
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_ORG_ID: (state, orgId) => {
    state.orgId = orgId
    localStorage.setItem('orgId', JSON.stringify(orgId))
  },
  SET_ORG_NAME: (state, orgName) => {
    state.orgName = orgName
    localStorage.setItem('orgName', JSON.stringify(orgName))
  },
  SET_ORG_CATEGORY: (state, orgCategory) => {
    state.orgCategory = orgCategory
    localStorage.setItem('orgCategory', JSON.stringify(orgCategory))
  },
  SET_EXPIRED_STATUS: (state, expiredStatus) => {
    state.expiredStatus = expiredStatus
    localStorage.setItem('expiredStatus', JSON.stringify(expiredStatus))
  },
  SET_MEMBER_VALID_DATE: (state, memberValidDate) => {
    state.memberValidDate = memberValidDate
    localStorage.setItem('memberValidDate', JSON.stringify(memberValidDate))
  },
  SET_ROUTES: (state, routes) => {
    state.routesList = routes
  },
  SET_NAME: (state, name) => {
    state.name = name
    localStorage.setItem('userName', JSON.stringify(name))
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_SERVICECODE: (state, serviceCodes) => {
    state.serviceCodes = serviceCodes
    localStorage.setItem('serviceCodes', serviceCodes)
  },
  SET_USERID: (state, userId) => {
    state.userId = userId
    localStorage.setItem('userId', JSON.stringify(userId))
  },
  SET_DEPTID: (state, deptId) => {
    state.deptId = deptId
    localStorage.setItem('deptId', deptId)
  },
  SET_COMPANYID: (state, companyId) => {
    state.companyId = companyId
    localStorage.setItem('companyId', companyId)
  },
  SET_CREATEORDERROLE: (state, createOrderRole) => {
    state.createOrderRole = createOrderRole
    localStorage.setItem('createOrderRole', createOrderRole)
  },
  SET_USERLEVEL: (state, userLevel) => {
    state.userLevel = userLevel
    localStorage.setItem('userLevel', userLevel)
  },
  SET_MENUCODES:(state, menuCodes) => {
    state.menuCodes = menuCodes
    localStorage.setItem('menuCodes', JSON.stringify(menuCodes))
  },
  SET_ROLECODE:(state, roleCode) => {
    state.roleCode = roleCode
    localStorage.setItem('roleCode', JSON.stringify(roleCode))
  },
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { loginName, loginPassword, timeStamp, token } = userInfo
    return new Promise((resolve, reject) => {
      login({ loginName: loginName.trim(), loginPassword: loginPassword, token1: timeStamp, token2: token }).then(response => {
        const { data } = response
        if (response.code !== 0){
          if (response.message != null && '' != response.message){
            reject(response.message)
          }
        }
        commit('SET_TOKEN', data.token)
        commit('SET_USERID', data.id)
        commit('SET_ORG_ID', data.orgId)
        commit('SET_ORG_NAME', data.orgName)
        commit('SET_ORG_CATEGORY', data.orgCategory)
        commit('SET_EXPIRED_STATUS', data.expiredStatus)
        commit('SET_MEMBER_VALID_DATE', data.memberValidDate)
        commit('SET_SERVICECODE', data.serviceCodes)
        commit('SET_NAME', data.userName)
        commit('SET_COMPANYID',data.companyId)
        commit('SET_CREATEORDERROLE',data.createOrderRole)
        commit('SET_USERLEVEL',data.userLevel)
        commit('SET_MENUCODES',data.menuCodes)
        commit('SET_ROLECODE',data.roleCode)
        setToken(data.token)

        // 检查权益到期时间
        if (data.rightsDeadline) {
          const rightsDeadline = new Date(data.rightsDeadline);
          const now = new Date();
          const timeDiff = rightsDeadline.getTime() - now.getTime();
          const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

          if (daysDiff <= 3 && daysDiff >= 0) {
            // 距离到期时间小于等于3天，弹窗提示
            setTimeout(() => {
              ElementUI.Message({
                message: '尊敬的用户,您好,系统使用费用临期,请与三日内完成支付,否则影响系统使用,谢谢!',
                type: 'warning',
                duration: 0, // 持久显示
                showClose: true
              });
            }, 1000); // 延迟1秒显示，确保登录流程完成
          }
        }

        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        const userInfo = response.data.user

        if (!userInfo) {
          return reject('Verification failed, please Login again.')
        }

        commit('SET_USERID', userInfo.userName)
        commit('SET_NAME', userInfo.userName)
        // commit('SET_AVATAR', avatar)
        resolve(userInfo)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
		removeToken() // must remove  token  first
		commit('RESET_STATE')
    localStorage.removeItem('userId')
		resolve()
      /* logout(state.token).then(() => {
        removeToken() // must remove  token  first
        commit('RESET_STATE')
        resolve()
      }).catch(error => {
        reject(error)
      }) */
    })
  },
  // 获取菜单
  generateRoutes({ commit }) {

    return new Promise((resolve, reject) => {
      menuList()
        .then(res => {
          const accessedRoutes = []
          if (res.rows.length > 0) {
            MenuUtils(accessedRoutes, res.rows)
            commit('SET_ROUTES', accessedRoutes)
            resolve(accessedRoutes)
          } else {
            if(res.code==1 || res.code ==9){
              reject(new Error(res.msg))
              return
            }else{
              // 如果菜单为空，拒绝Promise并提示错误
              reject(new Error('您没有任何菜单权限，请联系管理员分配权限'))
            }
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/user.js